// extracted by css-extract-rspack-plugin
export default {"illustration":"snBUCM"};